import { render, staticRenderFns } from "./DraftProcessList.vue?vue&type=template&id=01c0461b&scoped=true"
import script from "./DraftProcessList.vue?vue&type=script&lang=js"
export * from "./DraftProcessList.vue?vue&type=script&lang=js"
import style0 from "./DraftProcessList.vue?vue&type=style&index=0&id=01c0461b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c0461b",
  null
  
)

export default component.exports